/**
 * @description: CustomModificarUsuario
 * @author: Santiago Hernández N,
 * @version: jdesk_1.01.0009.5
 **/
import FormJaivana from 'dashboard_jaivana_v1';
class CustomModificarUsuario extends FormJaivana.form {


    constructor(props) {
        

        super(props);
        // Variables de tablas:
        this.gridOptionsComponentesInicial                              = Object.assign({},this.gridOptions);
        this.onSelectionChangedPrimero                                  = this.onSelectionChangedPrimero.bind(this);
        this.gridOptionsComponentesInicial['onSelectionChanged']        = this.onSelectionChangedPrimero;
        this.gridOptionsSucursales                                      = Object.assign({},this.gridOptions);
        this.gridOptionsFacturaciones                                   = Object.assign({},this.gridOptions);    
       
        // Variables Globales:
        this.configCell2                                                = new Map();
        this.configCell3                                                = new Map();
        this.row_inicial                                                = [];

        // Funciones:
        this.initForm                                                   = this.initForm.bind(this);        
        //TAB0
        this.traerUsuarios                                              = this.traerUsuarios.bind(this);
        this.sucessConsultarUsuarios                                    = this.sucessConsultarUsuarios.bind(this);
        this.crearBotonModificar                                        = this.crearBotonModificar.bind(this);
        this.accionModificar                                            = this.accionModificar.bind(this);
        this.subString50                                                = this.subString50.bind(this);
        //TAB1
        this.deshabilitarCampos                                         = this.deshabilitarCampos.bind(this);
        this.validarContinuarTab1                                       = this.validarContinuarTab1.bind(this);
        this.LimpiarTab1                                                = this.LimpiarTab1.bind(this);
        //TAB2
        this.initFormT2                                                 = this.initFormT2.bind(this);
        this.traerSucursalesActivas                                     = this.traerSucursalesActivas.bind(this);
        this.sucessTraerSucursales                                      = this.sucessTraerSucursales.bind(this);
        this.setButtonsTable                                            = this.setButtonsTable.bind(this);
        this.crearBotonTabla                                            = this.crearBotonTabla.bind(this);
        this.accionProcesar                                             = this.accionProcesar.bind(this);
        this.actualizarCampoSucursales                                  = this.actualizarCampoSucursales.bind(this);
        this.validarContinuarTab2                                       = this.validarContinuarTab2.bind(this);
        this.LimpiarTab2                                                = this.LimpiarTab2.bind(this);
        //TAB3
        this.initFormT3                                                 = this.initFormT3.bind(this);
        this.traerVendedores                                            = this.traerVendedores.bind(this);
        this.validarContinuarTab3                                       = this.validarContinuarTab3.bind(this);
        this.LimpiarTab3                                                = this.LimpiarTab3.bind(this);
        this.traerFacturaciones                                         = this.traerFacturaciones.bind(this);
        this.sucessTraerFacturaciones                                   = this.sucessTraerFacturaciones.bind(this);
        this.setButtonsTableFacturaciones                               = this.setButtonsTableFacturaciones.bind(this);
        this.crearBotonTablaFacturaciones                               = this.crearBotonTablaFacturaciones.bind(this);
        this.accionProcesarFacturaciones                                = this.accionProcesarFacturaciones.bind(this);
        this.actualizarCampoFacturaciones                               = this.actualizarCampoFacturaciones.bind(this);
        //TAB4
        this.initFormT4                                                 = this.initFormT4.bind(this);     
        this.validarContinuarTab4                                       = this.validarContinuarTab4.bind(this);
        this.LimpiarTab4                                                = this.LimpiarTab4.bind(this);
        //TAB5
        this.initFormT5                                                 = this.initFormT5.bind(this);
        this.validarContinuarTab5                                       = this.validarContinuarTab5.bind(this);
        this.LimpiarTab5                                                = this.LimpiarTab5.bind(this);
        this.sucessValidarModificarUsuario                              = this.sucessValidarModificarUsuario.bind(this);
        this.sucessModificarUsuario                                     = this.sucessModificarUsuario.bind(this);
        this.limpiartodo                                                = this.limpiartodo.bind(this);

        //CONFIGURACION
        this.currencyFormatterGeneral                                   = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo                                          = this.formatNumberSaldo.bind(this);
    }

    initForm() {
        console.log('Formulario CustomModificarUsuario,  @version: jdesk_1.01.0009.5, @author: Santiago Hernández N.');
        //TAB0
        this.traerUsuarios();
        this.getField("codigo_interno").setDisabled(true);

        //TAB1
        this.deshabilitarCampos();
        this.getField('continuar_basicos').setClick(this.validarContinuarTab1);
        this.getField('cancelar_basicos').setClick(this.LimpiarTab1);    
        this.getField("nombre_usuario").setOnChange(this.subString50);
        
        //TAB2
        
        //this.getField('nombre_sucursal').setOnChange(this.traerSucursalesActivas);
        this.getField("nombre_sucursal").setDisabled(true);
        this.sucursalesSeleccionadas = new Set();
        this.getField('continuar_sucursales').setClick(this.validarContinuarTab2);
        this.getField('cancelar_sucursales').setClick(this.LimpiarTab2); 
        
        //TAB3
        this.getField("codigo_vendedor").setDisabled(true);
        this.getField("nombre_vendedor").setDisabled(true);
        this.getField('estadosino_vendedor').setOnChange(this.traerVendedores);
        this.facturacionesSeleccionadas = new Set();
        //this.getField("codigo_facturacion").setDisabled(true);
        //this.getField("detalle_facturacion").setDisabled(true);
        this.getField("bodega_principal").setDisabled(true);
        this.getField("nombre_bodega_principal").setDisabled(true);
        this.getField('continuar_ventas').setClick(this.validarContinuarTab3);
        this.getField('cancelar_ventas').setClick(this.LimpiarTab3); 
        

        //TAB4
        this.getField('continuar_cartera').setClick(this.validarContinuarTab4);
        this.getField('cancelar_cartera').setClick(this.LimpiarTab4);

        //TAB5
        this.getField('continuar_mas_datos').setClick(this.validarContinuarTab5);
        this.getField('cancelar_mas_datos').setClick(this.LimpiarTab5);

        //EMPEZAR DE NUEVO
        this.getField('TabJaivana_331').setClick(this.limpiartodo);
    }








    //TAB0
    onSelectionChangedPrimero(){
        this.row_inicial = this.gridOptionsComponentesInicial.api.getSelectedRows();
    }

    traerUsuarios(){
        let datos={ datos: {}};
        this.getField("tabla_usuarios").setTipoServicioOperacion("heus-modificarusuario-consultar");
        this.getField("tabla_usuarios").sendRequest(this.sucessConsultarUsuarios, datos);
    }
    
    sucessConsultarUsuarios(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            let configCell = new Map();
            configCell.set('accion', { cellRenderer: this.crearBotonModificar, width: 110, sortable: false, filter: false, field: 'accion' });
            //configCell.set('veces_bloqueo_cupo',{cellRenderer:function(props){return"".formatoPrecio(props.data.veces_bloqueo_cupo)},width:120,field:'veces_bloqueo_cupo' }); 
            configCell.set('veces_bloqueo_cupo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.veces_bloqueo_cupo) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('veces_dias', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.veces_dias) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('valor_dias', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.valor_dias) }, cellStyle: { textAlign: "right" }, width: 110 });
            configCell.set('valor_bloqueo_cupo', { cellRenderer: (props) => { return "" + this.currencyFormatterGeneral(props.data.valor_bloqueo_cupo) }, cellStyle: { textAlign: "right" }, width: 110 });
            this.gridOptionsComponentesInicial['rowData'] = data.data;
            this.getField('tabla_usuarios').setPaginationSize(15);
            this.getField('tabla_usuarios').initData(this.gridOptionsComponentesInicial,configCell);
            if(this.gridOptionsComponentesInicial.api!==undefined)
              this.gridOptionsComponentesInicial.api.deselectAll();
            
        }else{
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true,'No hay datos','error');
            } else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        }
    }



    crearBotonModificar(props) {

        let button = document.createElement("input");
        button.onclick = () => this.accionModificar(props.data);
        button.setAttribute("codigo", 'button_modificar_' + props.data.codigo);
        button.setAttribute("class", "buttonStyle");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Modificar");
        return this.createElementJaivana(button);
    }

    accionModificar(data){
        this.getField('TabJaivana_331').setNextTab();
        this.getField("usuario_id").setValue(data.usuario_id);

        //TAB1
        this.getField("codigo_interno").setValue(data.codigo);
        this.getField("nit").setValue(data.cedula);
        this.getField("sede").setValue(data.sede);
        this.getField("terceros_id").setValue(data.tercero_id);
        this.getField("nombre").setValue(data.nombre_tercero);
        this.getField("nombre_usuario").setValue(data.nombre);    
        this.getField("email").setValue(data.email);
        this.getField("alias").setValue(data.alias);
        this.getField("estadosactivos_id").setValue(data.usuario_estadoactivo_id);



        //TAB2
        this.getField("codigo_interno_sucursales").setValue(data.codigo);
        this.getField("nombre_usuario_sucursales").setValue(data.nombre);          
        this.getField("sucursal_principal").setValue(data.codigo_sucursal);
        //this.getField("sucursales_permitidas").setValue(data.sucursal_configuracion);
        
        // Agregar la sucursal principal (siempre debe estar)
        if (data.codigo_sucursal) {
            this.sucursalesSeleccionadas.add(data.codigo_sucursal.trim());
        }

        // Agregar sucursales configuradas (si existen)
        if (data.sucursal_configuracion) {
            data.sucursal_configuracion.split(",")
                .map(item => item.trim())
                .forEach(item => this.sucursalesSeleccionadas.add(item));
        }

        // Actualizar el campo sucursales_permitidas con el Set final
        this.getField("sucursales_permitidas").setValue(
            Array.from(this.sucursalesSeleccionadas).join(",")
        );

        /*if (data.sucursal_configuracion) {
            // split por coma, trim y convertir a Set
            this.sucursalesSeleccionadas = new Set(
                data.sucursal_configuracion.split(",").map(item => item.trim())
            );
        } else {
            this.sucursalesSeleccionadas = new Set();
        }*/

        this.getField("nombre_sucursal").setValue(data.nombre_sucursal);

        
        //TAB3
        this.getField("codigo_interno_ventas").setValue(data.codigo);
        this.getField("nombre_usuario_ventas").setValue(data.nombre);   
        this.getField("estadosino_vendedor").setValue(data.vendedoresatdosino_id);  
        this.getField("descripcion_estado_sino_vendedor").setValue(data.descripcion_estado_sino_vendedor);                
        this.getField("codigo_vendedor").setValue(data.codigo_vendedor);                
        this.getField("nombre_vendedor").setValue(data.nombre_vendedor);
        //this.getField("codigo_facturacion").setValue(data.codigo_facturacion);
        //this.getField("detalle_facturacion").setValue(data.detalle_facturacion);
        
        // Agregar facturaciones configuradas (si existen)
        if (data.codigo_facturacion) {
            data.codigo_facturacion.split(",")
                .map(item => item.trim())
                .forEach(item => this.facturacionesSeleccionadas.add(item));
        }

        // Actualizar el campo facturaciones_permitidas con el Set final
        this.getField("facturaciones_permitidas").setValue(
            Array.from(this.facturacionesSeleccionadas).join(",")
        );

        this.getField("bodega_principal").setValue(data.codigo_bodega);
        this.getField("nombre_bodega_principal").setValue(data.nombre_bodega);
        this.getField("estadosino_autorizado_costos").setValue(data.ver_margenestadosino_id);
        this.getField("descripcion_estado_sino_vermargen").setValue(data.descripcion_estado_sino_vermargen);  
        this.getField("vendedor_id").setValue(data.vendedor_id);
        this.getField("estadosino_supervisor").setValue(data.supervisoresatdosino_id);  
        this.getField("descripcion_estado_sino_supervisor").setValue(data.descripcion_estado_sino_supervisor);   
        
        
        //TAB4
        this.getField("codigo_interno_cartera").setValue(data.codigo);
        this.getField("nombre_usuario_cartera").setValue(data.nombre);
        this.getField("nivel_autorizacion").setValue(data.nivel_autorizacion);
        this.getField("estadosino_tipo_bloqueo_cupo").setValue(data.tipobloqueocupo_estadosino_id);
        this.getField("descripcion_estado_sino_bloqueocupo").setValue(data.descripcion_estado_sino_bloqueocupo);
        this.getField("valor_bloqueo_cupo").setValue(data.valor_bloqueo_cupo);
        this.getField("numero_veces_dias").setValue(data.veces_dias);
        this.getField("numero_veces_bloqueo_cupo").setValue(data.veces_bloqueo_cupo);
        this.getField("valor_dias").setValue(data.valor_dias);
        this.getField("estadosino_cheque_devuelto").setValue(data.chequedevuelto_estadosino_id);
        this.getField("descripcion_estado_sino_chequedevuelto").setValue(data.descripcion_estado_sino_chequedevuelto);
        
        
        
        //TAB5
        this.getField("codigo_interno_mas_datos").setValue(data.codigo);
        this.getField("nombre_usuario_mas_datos").setValue(data.nombre);
        this.getField("codigo_dptointerno").setValue(data.codigo_departamento_interno);
        this.getField("nombre_dptointerno").setValue(data.nombre_departamento_interno);
        this.getField("departamento_interno_id").setValue(data.departamento_interno_id);
        
  
        
    }
    















    //TAB1
    subString50(){
        const campo = this.getField('nombre_usuario');
        const valor = campo.getValue() || "";

        if (valor.length > 50) {
            campo.setValue(valor.substring(0, 50));
        }
    }

    deshabilitarCampos(){
        this.getField("nombre").setDisabled(true);
        this.getField("sede").setDisabled(true);
        this.getField("email").setDisabled(true);
        this.getField('alias').setValue(".");

    }

    validarContinuarTab1(){
        
        if(this.getField('codigo_interno').valid() && this.getField('nit').valid() && this.getField('estadosactivos_id').valid() &&
        this.getField('nombre_usuario').valid() && this.getField('email').valid() && this.getField('alias').valid()) {

            this.getField('TabJaivana_331').setNextTab();
            this.initFormT2();
            this.traerSucursalesActivas();
        }
    
    }

    LimpiarTab1(){
        //this.getField('codigo_interno').setValue("");
        this.getField('nit').setValue("");
        this.getField('sede').setValue("");
        this.getField('nombre').setValue("");
        this.getField('estadosactivos_id').setValue("");
        this.getField('nombre_usuario').setValue("");
        this.getField('email').setValue("");
        this.getField('alias').setValue("");

    }




















    //TAB2
    initFormT2(){
        this.getField("codigo_interno_sucursales").setDisabled(true);
        this.getField("nombre_usuario_sucursales").setDisabled(true);
        this.getField("codigo_interno_sucursales").setValue(this.getField("codigo_interno").getValue());
        this.getField("nombre_usuario_sucursales").setValue(this.getField("nombre_usuario").getValue());
    }


    traerSucursalesActivas(){
        if (this.getField("nombre_sucursal").getValue()!==''){
          
            let datos={datos:{}};

            this.generalFormatPmv = { tipo_servicio: '43', operacion: '1', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.sucessTraerSucursales,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });  
        }else{
            this.getField('rejilla').toggle(true);
            this.gridOptionsSucursales['rowData'] = [];
        }
    }

    sucessTraerSucursales(data){
        this.getField('nombre_sucursal').setError(false, "");
        if (!this.sucursalesSeleccionadas) {
            this.sucursalesSeleccionadas = new Set();
        }

        if (data.estado_p === 200 ){
            this.getField('rejilla').toggle(true);
            
            this.configCell2.set('accion', { cellRenderer: this.setButtonsTable, width: 150, sortable: false, filter: false, field: 'acciones' });
            this.gridOptionsSucursales['rowData'] = data.data;
            this.getField('rejilla').initData(this.gridOptionsSucursales, this.configCell2);
        }else{
            this.alertGeneral.toggle(true, 'No hay datos de sucursales.', 'error');
        }
    }

    setButtonsTable(props){
        try {
            let fragment = document.createDocumentFragment();
            let buttonA = this.crearBotonTabla(props.data, 'Agregar');
            let buttonI = this.crearBotonTabla(props.data, 'Eliminar');

            buttonA.setAttribute("class","buttonStyle2");
            buttonI.setAttribute("class","buttonStyle2");

            // Deshabilitar el botón Agregar si ya está seleccionado
            if (this.sucursalesSeleccionadas && this.sucursalesSeleccionadas.has(props.data.sucursales_codigo)) {
                buttonA.disabled = true;
            }

            fragment.appendChild(buttonA);
            fragment.appendChild(buttonI);
            return this.createElementJaivana(fragment)
        } catch (error) {
            this.alertGeneral.toggle(true, 'Error cargando las acciones.', 'error');
        }
    }

    crearBotonTabla(data, boton) {
        let button = document.createElement('input');
        switch (boton) {
            case 'Agregar':
                button.setAttribute("id", `buttonAgregar_${data.id}`);
                break;

            case 'Eliminar':
                button.setAttribute("id", `buttonEliminar_${data.id}`);
                break;

            default:
                break;
        }
        button.onclick = () => { this.accionProcesar(data, boton) };
        button.setAttribute("value", boton);
        button.setAttribute("type", "button");
        return button;

    }

    accionProcesar(data, boton) {
        if (boton === 'Eliminar') {
            this.getField('confirmModalCustom').setTitleAndContent('Eliminar', '¿Desea realizar esta operación?');
            this.getField('confirmModalCustom').setClickDialog(() => { 
                
                // Eliminar del Set y actualizar campo
                this.sucursalesSeleccionadas.delete(data.sucursales_codigo);
                this.actualizarCampoSucursales();
                this.getField('confirmModalCustom').toggle(false);
            });
            this.getField("confirmModalCustom").setVisibleCancel(false);
            this.getField("confirmModalCustom").setButtonConfirm(`Confirmar`);
            this.getField('confirmModalCustom').toggle(true);

        } else if (boton === 'Agregar') {
            
            // Agregar al Set y actualizar campo
            this.sucursalesSeleccionadas.add(data.sucursales_codigo);
            this.actualizarCampoSucursales();

        } else {
            this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `Ninguna acción pertenece a la acción de este botón`);
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
            this.getField('confirmModalCustom').toggle(true);
        }
    }

    actualizarCampoSucursales() {
        const valorConcatenado = Array.from(this.sucursalesSeleccionadas).join(',');
        this.getField("sucursales_permitidas").setValue(valorConcatenado);
    }

    validarContinuarTab2(){
        if(this.getField('nombre_sucursal').valid() && this.getField('sucursales_permitidas').valid()) {
            this.getField('TabJaivana_331').setNextTab();   
            this.initFormT3();         
            this.traerFacturaciones();
        }
    }

    LimpiarTab2(){
        //this.gridOptionsSucursales['rowData'] = [];
        //this.getField('rejilla').toggle(false); 
                
        //this.getField('sucursales_permitidas').setValue("");
        this.getField('nombre_sucursal').setValue("");
        this.getField('sucursal_principal').setValue("");
        //this.sucursalesSeleccionadas = new Set();
    }
    















    //TAB3
    initFormT3(){
        this.getField("codigo_interno_ventas").setDisabled(true);
        this.getField("nombre_usuario_ventas").setDisabled(true);
        this.getField("codigo_interno_ventas").setValue(this.getField("codigo_interno").getValue());
        this.getField("nombre_usuario_ventas").setValue(this.getField("nombre_usuario").getValue());
    }

    traerFacturaciones(){
          
        let datos={datos:{}};

        this.generalFormatPmv = { tipo_servicio: 'maes-facturaciones', operacion: '1_1', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.sucessTraerFacturaciones,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
        });  

    }

    sucessTraerFacturaciones(data){
        if (!this.facturacionesSeleccionadas) {
            this.facturacionesSeleccionadas = new Set();
        }

        if (data.estado_p === 200 ){
            this.getField('rejilla_facturaciones').toggle(true);
            
            this.configCell3.set('accion', { cellRenderer: this.setButtonsTableFacturaciones, width: 150, sortable: false, filter: false, field: 'acciones' });
            this.gridOptionsFacturaciones['rowData'] = data.data;
            this.getField('rejilla_facturaciones').initData(this.gridOptionsFacturaciones, this.configCell3);
        }else{
            this.alertGeneral.toggle(true, 'No hay datos de facturaciones.', 'error');
        }
    }

    setButtonsTableFacturaciones(props){
        try {
            let fragment = document.createDocumentFragment();
            let buttonA = this.crearBotonTablaFacturaciones(props.data, 'Agregar');
            let buttonI = this.crearBotonTablaFacturaciones(props.data, 'Eliminar');

            buttonA.setAttribute("class","buttonStyle2");
            buttonI.setAttribute("class","buttonStyle2");

            // Deshabilitar el botón Agregar si ya está seleccionado
            if (this.facturacionesSeleccionadas && this.facturacionesSeleccionadas.has(props.data.codigo_facturacion)) {
                buttonA.disabled = true;
            }

            fragment.appendChild(buttonA);
            fragment.appendChild(buttonI);
            return this.createElementJaivana(fragment)
        } catch (error) {
            this.alertGeneral.toggle(true, 'Error cargando las acciones.', 'error');
        }
    }

    crearBotonTablaFacturaciones(data, boton) {
        let button = document.createElement('input');
        switch (boton) {
            case 'Agregar':
                button.setAttribute("id", `buttonAgregar_${data.id}`);
                break;

            case 'Eliminar':
                button.setAttribute("id", `buttonEliminar_${data.id}`);
                break;

            default:
                break;
        }
        button.onclick = () => { this.accionProcesarFacturaciones(data, boton) };
        button.setAttribute("value", boton);
        button.setAttribute("type", "button");
        return button;

    }

    accionProcesarFacturaciones(data, boton) {
        if (boton === 'Eliminar') {
            this.getField('confirmModalCustom').setTitleAndContent('Eliminar', '¿Desea realizar esta operación?');
            this.getField('confirmModalCustom').setClickDialog(() => { 
                // Eliminar del Set y actualizar campo
                this.facturacionesSeleccionadas.delete(data.codigo_facturacion);
                this.actualizarCampoFacturaciones();
                this.getField('confirmModalCustom').toggle(false);
            });
            this.getField("confirmModalCustom").setVisibleCancel(false);
            this.getField("confirmModalCustom").setButtonConfirm(`Confirmar`);
            this.getField('confirmModalCustom').toggle(true);

        } else if (boton === 'Agregar') {

            // Eliminar el punto inicial si es lo único que hay
            if (this.facturacionesSeleccionadas.has('.')) {
                this.facturacionesSeleccionadas.delete('.');
            }

            // Agregar al Set y actualizar campo
            this.facturacionesSeleccionadas.add(data.codigo_facturacion);
            this.actualizarCampoFacturaciones();

        } else {
            this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `Ninguna acción pertenece a la acción de este botón`);
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
            this.getField("confirmModalCustom").setVisibleCancel(true);
            this.getField("confirmModalCustom").setButtonConfirm(`Ok`);
            this.getField('confirmModalCustom').toggle(true);
        }
    }

    actualizarCampoFacturaciones() {
        const valorConcatenado = Array.from(this.facturacionesSeleccionadas).join(',');
        this.getField("facturaciones_permitidas").setValue(valorConcatenado);
    }


    traerVendedores(){
        const estado = Number(this.getField("estadosino_vendedor").getValue());

        if (estado === 1) {
            this.getField("codigo_vendedor").setDisabled(false);
            this.getField("nombre_vendedor").setDisabled(false);
            this.getField("codigo_vendedor").setValue("");
            this.getField("nombre_vendedor").setValue("");
            this.getField("vendedor_id").setValue("");            
            //this.getField("codigo_facturacion").setDisabled(false);
            //this.getField("detalle_facturacion").setDisabled(false);
            //this.getField("codigo_facturacion").setValue("");
            //this.getField("detalle_facturacion").setValue("");
            this.getField("bodega_principal").setDisabled(false);
            this.getField("nombre_bodega_principal").setDisabled(false);
            this.getField("bodega_principal").setValue("");
            this.getField("nombre_bodega_principal").setValue("");
        } else if (estado === 2) {
            this.getField("codigo_vendedor").setDisabled(true);
            this.getField("nombre_vendedor").setDisabled(true);
            this.getField("codigo_vendedor").setValue(".");
            this.getField("nombre_vendedor").setValue(".");
            this.getField("vendedor_id").setValue("");        
            //this.getField("codigo_facturacion").setDisabled(true);
            //this.getField("detalle_facturacion").setDisabled(true);
            //this.getField("codigo_facturacion").setValue(".");
            //this.getField("detalle_facturacion").setValue(".");
            this.getField("bodega_principal").setDisabled(true);
            this.getField("nombre_bodega_principal").setDisabled(true);
            this.getField("bodega_principal").setValue(".");
            this.getField("nombre_bodega_principal").setValue(".");   
        } else {
            this.getField("codigo_vendedor").setDisabled(true);
            this.getField("nombre_vendedor").setDisabled(true);
            this.getField("codigo_vendedor").setValue("");
            this.getField("nombre_vendedor").setValue("");
            this.getField("vendedor_id").setValue("");
            //this.getField("codigo_facturacion").setDisabled(true);
            //this.getField("detalle_facturacion").setDisabled(true);
            //this.getField("codigo_facturacion").setValue("");
            //this.getField("detalle_facturacion").setValue("");
            this.getField("bodega_principal").setDisabled(true);
            this.getField("nombre_bodega_principal").setDisabled(true);
            this.getField("bodega_principal").setValue("");
            this.getField("nombre_bodega_principal").setValue("");   
        }      
    }

    validarContinuarTab3(){
        if(this.getField('estadosino_vendedor').valid() && this.getField('nombre_vendedor').valid() /*&& this.getField('detalle_facturacion').valid()*/  && this.getField('facturaciones_permitidas').valid()
        && this.getField('nombre_bodega_principal').valid() && this.getField('estadosino_supervisor').valid() && this.getField('estadosino_autorizado_costos').valid()) {
            this.getField('TabJaivana_331').setNextTab();   
            this.initFormT4();         
        }
    }

    LimpiarTab3(){                
        this.getField('estadosino_vendedor').setValue("");
        this.getField('estadosino_supervisor').setValue("");
        this.getField('estadosino_autorizado_costos').setValue("");
        this.getField("codigo_vendedor").setDisabled(true);
        this.getField("nombre_vendedor").setDisabled(true);
        this.getField("codigo_vendedor").setValue("");
        this.getField("nombre_vendedor").setValue("");
        this.getField("vendedor_id").setValue("");
        //this.getField("codigo_facturacion").setDisabled(true);
        //this.getField("detalle_facturacion").setDisabled(true);
        //this.getField("codigo_facturacion").setValue("");
        //this.getField("detalle_facturacion").setValue("");
        this.getField("bodega_principal").setDisabled(true);
        this.getField("nombre_bodega_principal").setDisabled(true);
        this.getField("bodega_principal").setValue("");
        this.getField("nombre_bodega_principal").setValue("");    
    }




















    //TAB4
    initFormT4(){
        this.getField("codigo_interno_cartera").setDisabled(true);
        this.getField("nombre_usuario_cartera").setDisabled(true);
        this.getField("codigo_interno_cartera").setValue(this.getField("codigo_interno").getValue());
        this.getField("nombre_usuario_cartera").setValue(this.getField("nombre_usuario").getValue());
    }

    validarContinuarTab4() {
        const valor = this.getField("nivel_autorizacion").getValue() || "";

        // Validar que sea exactamente 2 dígitos y dentro del rango 00 - 10
        const regex = /^(0[0-9]|10)$/;

        if (!regex.test(valor)) {
            this.getField("nivel_autorizacion").setError(true, '*Valor inválido. Solo se permiten 00 a 10');
            return;
        }

        // Validar que ciertos campos sean mayores a 0
        const numero_veces_dias = Number(this.getField("numero_veces_dias").getValue());
        const numero_veces_bloqueo_cupo = Number(this.getField("numero_veces_bloqueo_cupo").getValue());
        const valor_dias = Number(this.getField("valor_dias").getValue());

        if (numero_veces_dias <= 0) {
            this.getField("numero_veces_dias").setError(true, 'Debe ser mayor a 0');
            return;
        }
        if (numero_veces_bloqueo_cupo <= 0) {
            this.getField("numero_veces_bloqueo_cupo").setError(true, 'Debe ser mayor a 0');
            return;
        }
        if (valor_dias <= 0) {
            this.getField("valor_dias").setError(true, 'Debe ser mayor a 0');
            return;
        }

        // Validación de los demás campos
        if (this.getField("nivel_autorizacion").valid() &&
            this.getField("estadosino_tipo_bloqueo_cupo").valid() &&
            this.getField("valor_bloqueo_cupo").valid() &&
            this.getField("numero_veces_dias").valid() &&
            this.getField("numero_veces_bloqueo_cupo").valid() &&
            this.getField("estadosino_cheque_devuelto").valid()) {

            this.getField('TabJaivana_331').setNextTab();
            this.initFormT5();
        }
    }

    LimpiarTab4(){
        this.getField("nivel_autorizacion").setValue("");
        this.getField("estadosino_tipo_bloqueo_cupo").setValue("");
        this.getField("valor_bloqueo_cupo").setValue("");
        this.getField("numero_veces_dias").setValue("");
        this.getField("numero_veces_bloqueo_cupo").setValue("");
        this.getField("estadosino_cheque_devuelto").setValue("");
        this.getField("valor_dias").setValue("");
    }





















    //TAB5
    initFormT5(){
        this.getField("codigo_interno_mas_datos").setDisabled(true);
        this.getField("nombre_usuario_mas_datos").setDisabled(true);
        this.getField("codigo_interno_mas_datos").setValue(this.getField("codigo_interno").getValue());
        this.getField("nombre_usuario_mas_datos").setValue(this.getField("nombre_usuario").getValue());
    }

    validarContinuarTab5(){
        if (this.getField("nombre_dptointerno").valid()){
            let datos={ datos: {codigo_interno: this.getField('codigo_interno').getValue()}};

            this.generalFormatPmv = { tipo_servicio: 'heus-modificarusuario', operacion: 'validarusuario', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.sucessValidarModificarUsuario,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });
        }
    }

    sucessValidarModificarUsuario(data){
        if (data.estado_p === 200 ){
            let datos={ 
                datos: {
                    codigo_interno: this.getField('codigo_interno').getValue(),
                    nombre: this.getField('nombre_usuario').getValue(),
                    nit: this.getField('nit').getValue(),
                    terceros_id: Number(this.getField('terceros_id').getValue()),
                    estado:Number(this.getField('estadosactivos_id').getValue())===1 ? 'A':'I',
                    estadoactivo_id:Number(this.getField('estadosactivos_id').getValue()),
                    alias:this.getField('alias').getValue(),
                    vendedor:this.getField('descripcion_estado_sino_vendedor').getValue(),
                    supervisor:this.getField('descripcion_estado_sino_supervisor').getValue(),
                    cvendedor:this.getField('codigo_vendedor').getValue(),
                    ver_margen:this.getField('descripcion_estado_sino_vermargen').getValue(),
                    codigo_facturacion:this.getField('facturaciones_permitidas').getValue(),
                    codigo_sucursal:this.getField('sucursal_principal').getValue(),
                    tipo_bloqueo_cupo:this.getField('descripcion_estado_sino_bloqueocupo').getValue(),
                    tipobloqueocupo_estadosino_id:Number(this.getField('estadosino_tipo_bloqueo_cupo').getValue()),
                    valor_bloqueo_cupo:this.getField('valor_bloqueo_cupo').getValue(),
                    veces_dias:this.getField('numero_veces_dias').getValue(),
                    valor_dias:this.getField('valor_dias').getValue(),
                    veces_bloqueo_cupo:this.getField('numero_veces_bloqueo_cupo').getValue(),
                    cheque_devuelto:this.getField('descripcion_estado_sino_chequedevuelto').getValue(),
                    chequedevuelto_estadosino_id:Number(this.getField('estadosino_cheque_devuelto').getValue()),
                    nivel_autorizacion:this.getField('nivel_autorizacion').getValue(),
                    bodega:this.getField('bodega_principal').getValue(),
                    codigo_vendedor:this.getField('codigo_vendedor').getValue(),
                    sucursal_configuracion:this.getField('sucursales_permitidas').getValue(),
                    supervisoresatdosino_id:Number(this.getField('estadosino_supervisor').getValue()),
                    vendedoresatdosino_id:Number(this.getField('estadosino_vendedor').getValue()),
                    ver_margenestadosino_id:Number(this.getField('estadosino_autorizado_costos').getValue()),
                    cedula:this.getField('nit').getValue(),
                    codigodepartamento_id:Number(this.getField('departamento_interno_id').getValue()),
                    usuario_id:Number(this.getField('usuario_id').getValue()),
                    codigo_dptointerno:this.getField('codigo_dptointerno').getValue(),
                }
            };

            this.generalFormatPmv = { tipo_servicio: 'heus-modificarusuario', operacion: 'modificarusuario', operacion_tipo: 'crear' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'PUT',
                    body: datos,
                    success: this.sucessModificarUsuario,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });

            
        }else{
            this.alertGeneral.toggle(true, 'El código del usuario no existe, por favor crearlo.', 'error');
        }

    }

    sucessModificarUsuario(data){
        if (data.estado_p === 200 ){
            this.alertGeneral.toggle(true, 'Usuario actualizado con éxito', 'success');
            this.limpiartodo();
            this.traerUsuarios();
        }else{
            this.alertGeneral.toggle(true, 'No se pudo actualizar el usuario', 'error');
            this.limpiartodo();
        }
    }

    LimpiarTab5(){
        this.getField("codigo_dptointerno").setValue("");
        this.getField("nombre_dptointerno").setValue("");

    }














    

    //EMPEZAR DE NUEVO
    limpiartodo(){
        this.getField('TabJaivana_331').reInit();
        this.getField('codigo_interno').setValue("");
        this.getField('nit').setValue("");
        this.getField('sede').setValue("");
        this.getField('nombre').setValue("");
        this.getField('estadosactivos_id').setValue("");
        this.getField('nombre_usuario').setValue("");
        this.getField('email').setValue("");
        this.getField('alias').setValue("");
        this.gridOptionsSucursales['rowData'] = [];
        this.getField('rejilla').toggle(false);                 
        this.getField('sucursales_permitidas').setValue("");
        this.getField('nombre_sucursal').setValue("");
        this.getField('sucursal_principal').setValue("");
        this.getField('estadosino_vendedor').setValue("");
        this.getField('estadosino_supervisor').setValue("");
        this.getField('estadosino_autorizado_costos').setValue("");
        this.getField("codigo_vendedor").setDisabled(true);
        this.getField("nombre_vendedor").setDisabled(true);
        this.getField("codigo_vendedor").setValue("");
        this.getField("nombre_vendedor").setValue("");
        this.getField("vendedor_id").setValue("");
        //this.getField("codigo_facturacion").setDisabled(true);
        //this.getField("detalle_facturacion").setDisabled(true);
        //this.getField("codigo_facturacion").setValue("");
        //this.getField("detalle_facturacion").setValue("");
        this.getField("bodega_principal").setDisabled(true);
        this.getField("nombre_bodega_principal").setDisabled(true);
        this.getField("bodega_principal").setValue("");
        this.getField("nombre_bodega_principal").setValue("");  
        this.getField("nivel_autorizacion").setValue("00");
        this.getField("estadosino_tipo_bloqueo_cupo").setValue("");
        this.getField("valor_bloqueo_cupo").setValue("0");
        this.getField("numero_veces_dias").setValue("0");
        this.getField("numero_veces_bloqueo_cupo").setValue("0");
        this.getField("estadosino_cheque_devuelto").setValue("");  
        this.getField("codigo_dptointerno").setValue("");
        this.getField("nombre_dptointerno").setValue("");
        this.getField('alias').setValue(".");
        this.getField("valor_dias").setValue("0");
        this.sucursalesSeleccionadas = new Set();
        this.facturacionesSeleccionadas = new Set();
        this.getField('facturaciones_permitidas').setValue("");

    }






    //CONFIGURACION
    currencyFormatterGeneral(number) {
        let decimal = (number + "").split(".")[1];//para manejar los decimales
        if ((decimal !== 0) && (decimal !== undefined)) {
            if (decimal.length > this.numero_decimales) {
                number = number.toFixed(this.numero_decimales); //para que redondea a dos decimales
                decimal = (number + "").split(".")[1];
            }
            return (this.formatNumberSaldo(number) + "," + decimal);
        } else {
            return this.formatNumberSaldo(number);
        }
    }

    formatNumberSaldo(number) {
        return Number(number).toFixed(this.numero_decimales).toString().split('.')[0]
            .toString()
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }

}
FormJaivana.addController('heus-modificarusuario', CustomModificarUsuario);
export default CustomModificarUsuario;